export default __webpack_public_path__ + "static/media/singlePlatform.e20713e7.svg";